import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';

import { showSuccessSnackbar } from 'modules/snackbar';
import { makeRowColumn, getHeadObj, makeHeadData } from 'lib/commonLib';
import { advrtsLiveKeywordList } from 'lib/api/adverlive';

import BasicTable from 'components/molecules/MbBasicTable';

import Modal from 'components/organisms/NewModal';

const useStyles = makeStyles((theme) => ({ basicTable: { minWidth: 300 } }));
const StatisticsModal = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const { modalParams, handleSubmit, handleClose } = props;
  const [images, setImages] = useState([]);
  const [tableData, setTableData] = useState({ KEYWORD: [], MEDIA: [] });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (modalParams.type === 'images') {
      let tempImages = [];
      for (let i = 2; i < 7; i++) {
        if (modalParams.rowData['IMAGE_URL' + i] !== null) {
          tempImages.push(modalParams.rowData['IMAGE_URL' + i]);
        }
      }
      setImages(tempImages);
    }
  }, [modalParams]);

  useEffect(() => {
    if (
      modalParams.type === 'keyword' &&
      modalParams.rowData['SITE_CODE'] !== undefined
    ) {
      setLoading(true);
      advrtsLiveKeywordList({ siteCode: modalParams.rowData['SITE_CODE'] })
        .then((response) => {
          const { data } = response.data;
          setTableData({ ...tableData, KEYWORD: data });
          setLoading(false);
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: { type: 'error' },
          });
        });
    }
    // eslint-disable-next-line
  }, [modalParams.rowData['SITE_CODE']]);

  const tableInfoJson = {
    KEYWORD: {
      headList: [
        {
          id: 'KWRD_SEQ',
          label: 'SEQ',
          orderFlag: false,
          type: 'number',
          format: '#,##0',
        },
        {
          id: 'KWRD_NM',
          label: '키워드',
          orderFlag: false,
          type: 'string',
          format: '@',
        },
      ],
      sort: 'desc',
      order: 'KWRD_NM',
    },
    MEDIA: {
      headList: [
        {
          id: 'STATS_DTTM',
          label: 'MEDIA',
          orderFlag: true,
          type: 'string',
          format: '@',
        },
        {
          id: 'TOT_EPRS_CNT',
          label: '모비온 요청수',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
        },
        {
          id: 'PAR_EPRS_CNT',
          label: '광고 요청수',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
        },
        {
          id: 'EXL_ITL_EPRS_RATE',
          label: '게재율',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
        },
        {
          id: 'CTR',
          label: 'CTR',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
        },
        {
          id: 'CPC',
          label: 'CPC',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
        },
        {
          id: 'ADVRTS_AMT',
          label: '소진금액',
          orderFlag: true,
          type: 'number',
          format: '#,##0',
        },
      ],
      sort: 'desc',
      order: 'STATS_DTTM',
    },
  };

  const customized = {
    KEYWORD: {
      KWRD_NM: {
        makeBody: (rowObj, headsMap) => {
          const statsDttm = getHeadObj(headsMap, 'KWRD_NM');
          return makeRowColumn(
            rowObj['KWRD_NM'],
            statsDttm.type,
            statsDttm.format
          );
        },
        bodyStyle: { width: 200, textAlign: 'center' },
      },
    },
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <Modal
        open={modalParams.open}
        headerOpen={false}
        cancelBtnOpen={false}
        confirmBtnTitle={t('확인')}
        handleClose={handleClose}
        confirmOnClick={handleSubmit}
      >
        {modalParams['type'] === 'keyword' && (
          <>
            <BasicTable
              sort={tableInfoJson['KEYWORD'].sort}
              order={tableInfoJson['KEYWORD'].order}
              list={tableData['KEYWORD']}
              headCells={makeHeadData(tableInfoJson['KEYWORD'].headList)}
              loading={loading}
              className={`${classes.basicTable}`}
              customized={customized['KEYWORD']}
            />
          </>
        )}
        {modalParams['type'] === 'media' && (
          <>
            <BasicTable
              sort={tableInfoJson['MEDIA'].sort}
              order={tableInfoJson['MEDIA'].order}
              list={tableData['MEDIA']}
              headCells={makeHeadData(tableInfoJson['MEDIA'].headList)}
              loading={loading}
              // className={`${classes.issueTable} ${key}`}
              customized={customized['MEDIA']}
            />
          </>
        )}
        {modalParams['type'] === 'images' &&
          (images.length !== 0 ? (
            <>
              {images.map((image, i) => (
                <div key={i}>
                  <img
                    src={'//img.mobon.net/ad/imgfile/' + image}
                    //   height={i === 0 ? 'auto' : '150'}
                    height={'150'}
                    alt={'배너 이미지' + i}
                  />
                </div>
              ))}
            </>
          ) : (
            <p style={{ textAlign: 'center' }}>배너 이미지 없음</p>
          ))}
      </Modal>
    </>
  );
};

export default StatisticsModal;
